module.exports = __webpack_public_path__ + "static/media/29BDOS14.8e253fce.jpg";